'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _actions = require('../../../actions.js');

var _actions2 = _interopRequireDefault(_actions);

var _StepBase = require('../StepBase');

var _StepBase2 = _interopRequireDefault(_StepBase);

var _InvoicingAddress = require('./InvoicingAddress');

var _InvoicingAddress2 = _interopRequireDefault(_InvoicingAddress);

var _DeliveryTypeItem = require('./DeliveryTypeItem');

var _DeliveryTypeItem2 = _interopRequireDefault(_DeliveryTypeItem);

var _PaymentTypeItem = require('./PaymentTypeItem');

var _PaymentTypeItem2 = _interopRequireDefault(_PaymentTypeItem);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _SummaryBox = require('./SummaryBox');

var _SummaryBox2 = _interopRequireDefault(_SummaryBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    var options = (0, _linksoftAlbatros.getCartOptions)(state.cart);
    var allowedDeliveryTypes = getAllowedDeliveryTypes(state.cart.deliveryTypes, state.cart.items);
    var deliveryType = getDeliveryType(allowedDeliveryTypes, options.deliveryTypeId);
    var pickupPlaceRequired = deliveryType && deliveryType.pickupPlaces.length > 0;
    return {
        deliveryTypeId: deliveryType === null ? null : options.deliveryTypeId,
        paymentTypeId: options.paymentTypeId,
        pickupPlaceId: options.pickupPlaceId,
        deliveryTypes: allowedDeliveryTypes,
        paymentTypes: state.cart.paymentTypes,
        pickupPlaceRequired: pickupPlaceRequired || false,
        processing: !!(state.cart.processing || (0, _keys2.default)(state.cart.changedOptions).length)
    };
}

function getAllowedDeliveryTypes(deliveryTypes, items) {
    var totalCount = items.reduce(function (a, b) {
        return a + (b.amount || 0);
    }, 0);
    var result = [];
    for (var i = 0; i < deliveryTypes.length; i++) {
        var d = deliveryTypes[i];
        if (d.collection[0].maxOrderCount == null || totalCount <= d.collection[0].maxOrderCount) {
            result.push(d);
        }
    }
    return result;
}

function getDeliveryType(deliveryTypes, deliveryTypeId) {
    for (var i = 0; i < deliveryTypes.length; i++) {
        var d = deliveryTypes[i];
        var deliveryType = d.collection.find(function (x) {
            return x.id === deliveryTypeId;
        });
        if (deliveryType) return deliveryType;
    }
    return null;
}

var PaymentAndDeliveryStep = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_CartDetailStepBase) {
    (0, _inherits3.default)(PaymentAndDeliveryStep, _CartDetailStepBase);

    function PaymentAndDeliveryStep(props) {
        (0, _classCallCheck3.default)(this, PaymentAndDeliveryStep);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentAndDeliveryStep.__proto__ || (0, _getPrototypeOf2.default)(PaymentAndDeliveryStep)).call(this, props, 3));

        _this.state = {
            pristine: true
        };
        return _this;
    }

    (0, _createClass3.default)(PaymentAndDeliveryStep, [{
        key: 'nextStep',
        value: function nextStep() {
            if (this.canContinue()) {
                (0, _get3.default)(PaymentAndDeliveryStep.prototype.__proto__ || (0, _getPrototypeOf2.default)(PaymentAndDeliveryStep.prototype), 'nextStep', this).call(this);
            }
            this.setState({ pristine: false });
        }
    }, {
        key: 'canContinue',
        value: function canContinue() {
            var _props = this.props,
                deliveryTypeId = _props.deliveryTypeId,
                paymentTypeId = _props.paymentTypeId,
                pickupPlaceId = _props.pickupPlaceId,
                pickupPlaceRequired = _props.pickupPlaceRequired,
                processing = _props.processing;

            return !processing && typeof deliveryTypeId === 'number' && typeof paymentTypeId === 'number' && (!pickupPlaceRequired || typeof pickupPlaceId === 'number');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.isLoading()) {
                return _react2.default.createElement('div', { className: this.stepClass() });
            }
            var _props2 = this.props,
                deliveryTypes = _props2.deliveryTypes,
                paymentTypes = _props2.paymentTypes,
                deliveryTypeId = _props2.deliveryTypeId,
                paymentTypeId = _props2.paymentTypeId,
                pickupPlaceId = _props2.pickupPlaceId,
                pickupPlaceRequired = _props2.pickupPlaceRequired;
            var pristine = this.state.pristine;


            var submitBtnClass = 'btn btn--lg btn--green';
            if (!this.canContinue()) {
                submitBtnClass += ' btn--inactive';
            }

            var showDeliveryWarning = !pristine && (!deliveryTypeId || pickupPlaceRequired && !pickupPlaceId);

            return _react2.default.createElement(
                'div',
                { className: this.stepClass() },
                _react2.default.createElement(
                    'div',
                    { className: 'step__inner step__inner--3' },
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__wrap' },
                        _react2.default.createElement(
                            'h3',
                            { className: 'cart__section-title' },
                            Resx.App.ChooseTrasnportType,
                            ':\xA0',
                            !!showDeliveryWarning && _react2.default.createElement('i', { className: 'icon--caution' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'deliveryList' },
                            deliveryTypes.map(function (i) {
                                return _react2.default.createElement(_DeliveryTypeItem2.default, (0, _extends3.default)({ key: i.id }, i));
                            })
                        ),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(
                            'h3',
                            { className: 'cart__section-title space-t-40' },
                            Resx.App.ChoosePaymentType,
                            ':\xA0',
                            !pristine && !paymentTypeId && _react2.default.createElement('i', { className: 'icon--caution' })
                        ),
                        _react2.default.createElement(
                            'div',
                            { id: 'paymentList' },
                            paymentTypes.map(function (i) {
                                return _react2.default.createElement(_PaymentTypeItem2.default, (0, _extends3.default)({ key: i.id }, i));
                            })
                        ),
                        _react2.default.createElement('hr', null),
                        _react2.default.createElement(_InvoicingAddress2.default, null),
                        _react2.default.createElement('hr', null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'cart__aside' },
                        _react2.default.createElement(
                            'div',
                            { className: 'cart-summary' },
                            _react2.default.createElement(_SummaryBox2.default, { cart: this.props.cart }),
                            _react2.default.createElement(
                                'div',
                                { className: 'text-center mt-3' },
                                _react2.default.createElement(
                                    'button',
                                    {
                                        className: submitBtnClass,
                                        onClick: function onClick() {
                                            return _this2.nextStep();
                                        }
                                    },
                                    Resx.Common.Continue,
                                    _react2.default.createElement('i', { className: 'icon--arrow-right icon--arrow-right--after' })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'mt-5 text-center' },
                            _react2.default.createElement(
                                'button',
                                {
                                    className: 'btn btn--sm',
                                    onClick: function onClick() {
                                        return _this2.prevStep();
                                    }
                                },
                                '< ',
                                Resx.Common.Back
                            )
                        )
                    )
                )
            );
        }
    }]);
    return PaymentAndDeliveryStep;
}(_StepBase2.default), _class2.propTypes = {
    cart: _propTypes2.default.object.isRequired,
    deliveryTypeId: _propTypes2.default.number,
    paymentTypeId: _propTypes2.default.number,
    pickupPlaceId: _propTypes2.default.number,
    deliveryTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    paymentTypes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    pickupPlaceRequired: _propTypes2.default.bool.isRequired,
    processing: _propTypes2.default.bool
}, _temp)) || _class);
exports.default = PaymentAndDeliveryStep;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/Step.js
// module id = 1141
// module chunks = 0